{
    "firebase": {
        "apiKey": "AIzaSyAMX7TbxOh2n2puTqQqpppeSHRf43n9W8w",
        "authDomain": "flightline-alon-deveopment.firebaseapp.com",
        "projectId": "flightline-alon-deveopment",
        "storageBucket": "flightline-alon-deveopment.firebasestorage.app",
        "messagingSenderId": "169542687669",
        "appId": "1:169542687669:web:f5bdc378919df9c09d57fc"
    },
    "clientName": "Alon Environment",
    "pdfViewerKey": "d4b849d50ed5483c8bf51f2b390223c6",
    "domains": ["testing-flightline.web.app"]
}
